const SOCKET_ACTION_PREFIX = '@@app/socket'
const makeConstant = (constant) => `${SOCKET_ACTION_PREFIX}/${constant}`

export const AUTHENTICATE = makeConstant('AUTHENTICATE')
export const AUTHENTICATE_PENDING = makeConstant('AUTHENTICATE_PENDING')
export const AUTHENTICATE_SUCCESS = makeConstant('AUTHENTICATE_SUCCESS')
export const AUTHENTICATE_FAILURE = makeConstant('AUTHENTICATE_FAILURE')

export const CONNECT = makeConstant('CONNECT')

export const DISCONNECT = makeConstant('DISCONNECT')

export const JOIN_CHANNEL = makeConstant('JOIN_CHANNEL')
export const JOIN_CHANNEL_PENDING = makeConstant('JOIN_CHANNEL_PENDING')
export const JOIN_CHANNEL_SUCCESS = makeConstant('JOIN_CHANNEL_SUCCESS')
export const JOIN_CHANNEL_FAILURE = makeConstant('JOIN_CHANNEL_FAILURE')

export const LEAVE_CHANNEL = makeConstant('LEAVE_CHANNEL')

export const SOCKET_OPEN_EVENT_RECEIVED = makeConstant('SOCKET_OPEN_EVENT_RECEIVED')
export const SOCKET_CLOSE_EVENT_RECEIVED = makeConstant('SOCKET_CLOSE_EVENT_RECEIVED')
export const SOCKET_ERROR_EVENT_RECEIVED = makeConstant('SOCKET_ERROR_EVENT_RECEIVED')

export const SOCKET_RECONNECT_ATTEMPT_QUEUED = makeConstant('SOCKET_RECONNECT_ATTEMPT_QUEUED')
export const SOCKET_RECONNECT_TIMER_TICKED = makeConstant('SOCKET_RECONNECT_TIMER_TICKED')

export const CHANNEL_ERROR_EVENT_RECEIVED = makeConstant('CHANNEL_ERROR_EVENT_RECEIVED')
export const CHANNEL_CLOSE_EVENT_RECEIVED = makeConstant('CHANNEL_CLOSE_EVENT_RECEIVED')

export const SOCKET_STATES = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
  ERRORED: 4,
}

export const CHANNEL_STATES = {
  CLOSED: "closed",
  ERRORED: "errored",
  JOINED: "joined",
  JOINING: "joining",
  LEAVING: "leaving",
}

export const SocketCluster = Object.freeze({
  MESSAGES: 'MESSAGES',
  PUSH: 'PUSH',
})

export const SocketChannel = Object.freeze({
  USER: 'USER',
  ORG_PUBLIC: 'ORG_PUBLIC',
  ORG_PRIVATE: 'ORG_PRIVATE',
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/socket/constants.js